import styled from "styled-components";

export const ContainerDetal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;

  width: 100%;
`;


export const ProductTitleContainer = styled.div`
  span {
    font-size: 10px;
    font-weight: 400;
  }
`;

export const ProductPriceContainer = styled.div`
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .dynamic-price {
    color: var(--primary);
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 2px;

    .unit {
      font-size: 11px;
      font-weight: 400;
      color: var(--primary);
    }
  }

  .reference-price {
    color: #666;
    font-size: 10px;
    font-weight: 400;
    margin-bottom: 2px;
  }

  .single-price {
    color: var(--primary);
    font-size: 12px;
    font-weight: 600;

    .unit {
      font-size: 10px;
      font-weight: 400;
      color: var(--primary);
    }
  }

  /* Manter compatibilidade com spans antigos */
  span {
    color: var(--primary);
    font-size: 12px;
    font-weight: 600;
  }
`;

export const AlertMessageContainer = styled.div`
  width:100%;
  background-color: var(--primary);
  color: white;
  margin: 10px 0px;
  padding: 2px;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
`